export default "__VITE_ASSET__d4c2c3f6__"